import './App.css';
import NavBar from './components/NavBar';
import PageRoutes from './pages/PageRoutes';
import Footer from './components/Footer';
import { Divider, Flex } from 'antd';

function App() {
  return (
    <Flex vertical align='center' style={{ margin: '20px', backgroundColor: 'white', borderRadius: '16px', padding: '20px' }}>
      <NavBar />

      <Divider />
      
      <PageRoutes />

      <Divider />
      <Footer />
    </Flex>
  );
}

export default App;
